// extracted by mini-css-extract-plugin
export default {"iframe_bg":"Iframe_iframe_bg__FZUQV","iframe":"Iframe_iframe__368ON","page-fade-in":"Iframe_page-fade-in__zrOQY","iframe_close_dialog":"Iframe_iframe_close_dialog__VhkkR"};